import React from "react";
import Navbar from "../components/homePage/navBar";
import LogOut from "../components/login/LogOut";

const LogOutPage: React.FC = () => {
  return (
    <div>
      <Navbar />
      <LogOut />
    </div>
  );
};

export default LogOutPage;
